// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2pKAd","actions":"GroupTable_actions__WBwf4","deleteModalFooter":"GroupTable_deleteModalFooter__3wt5x"};